import React from 'react';
import './about.css';
import ABoutPic from '../Assets/about.jpg';
import {Card} from './Card/card';
import {Testimonial} from './Testimonial/testimonial';
import {Button} from './comman/Button/button';
import axios from 'axios';

export function About(props) {

    const getCv = () => {
        axios.get('http://localhost:5000/download/cv', {responseType: 'blob'})
        .then(file => {
            const blobFile = new Blob([file.data], {type: 'application/pdf'})
            let url = window.URL.createObjectURL(blobFile);
            let a = document.createElement('a');
            a.href = url;
            a.download = 'resume.pdf';
            a.click();
            a.remove();
        })
        .catch(err => {
            console.log(err);
        })
    }
    return (
        <div className = 'about container'>
            <div className = 'header row'>
                <h2>About Me </h2>
            </div>
            <div className = 'row'>
                <div className = 'col-lg-6'>
                    <div className = 'img'>
                        <img src= {ABoutPic} width = '100%' height = '100%'/>
                    </div>
                </div>
                <div className = 'col-lg-6'>
                <h3 className='about-heading'>
                I am <span>Ramneek Marwaha</span>
                </h3>
                <p className = 'para'>
                I am a frontend web developer. I can provide clean code and pixel perfect design. 
                I also make website more & more interactive with web animations.
                </p>
                <ul>
                    <li>
                        <b>Full Name</b><span className = 'span1'>Ramneek Marwaha</span> 
                    </li>
                    <li>
                        <b>Age</b> <span className = 'span2'>22 Years</span>
                    </li>
                    <li>
                        <b>Nationality</b> <span className = 'span3'>Indian</span>
                    </li>
                    <li>
                        <b>Language</b> <span className = 'span4'>English</span>
                    </li>
                </ul>
                    <Button title = {'Download CV'} click = {getCv}/>
                </div>
            </div>
            <div className = 'header row mt-5 pt-5'>
                <h2>Services </h2>
            </div>
            <div className= 'row '>
            <div className = 'col-lg-4 col-md-4 col-sm-4 center-card'>
                <Card title = {'Web Development'}/>
            </div>
            <div className = 'col-lg-4 col-md-4 col-sm-4 center-card' >
                <Card title = {'Web Design'}/>
            </div>
            <div className = 'col-lg-4 col-md-4 col-sm-4 center-card'>
                <Card title = {'Backend Development'}/>
            </div>
            </div>
            <div className = 'header row mt-5 pt-5 center-card'>
                <h2>Reviews </h2>
            </div>
            <div className = 'row'>
            <Testimonial/>
            </div>
        </div>
    )
}